import '../vendor/glitch';

export function wordAnimation(item) {
	item.glitch({
		chars: 'вфлаордлоапрыодраыдлвопдлыворпылодырвадлопрывалдопрыдловрпаывлподлжлаоывпждлопывадаопвыждлопаждылоапжвдопжыдвладжолыпавждлоавыдпоываджлпждлывоаджлповыа',
		charTime: 7,
	});
}
